export default "__VITE_ASSET__DVOacgEr__"